// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_tableHeader__9ULqd {
  border-bottom: 1px solid #eee;
  padding: 4px 4px 20px 4px;
}
.style_tableHeader__9ULqd h2 {
  font-size: 20px;
  margin: 0px;
}
.style_tableHeader__9ULqd .style_counter__ARW4G {
  color: var(--rs_black_100, #434243);
  font-size: 20px;
  font-weight: 700;
  margin-right: 26px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
}

.style_status__4RU-c {
  color: #ffc107;
  font-size: 12px;
  font-weight: 500;
  margin-left: 0px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--rs_yellow_10, #fff9e7);
  white-space: pre;
  margin: 0px;
  align-items: center;
}

.style_counter__ARW4G .style_statBox__MZLI6 {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--rs_grey_30, #eee);
}
.style_counter__ARW4G .style_statBox__MZLI6 p {
  padding: 0;
  margin: 0;
}

.style_new__yC17U {
  color: #757575;
  background: #f5f5f5;
}

.style_inProgress__O-QXf {
  color: #ffc107;
  background: #fff9e7;
}

.style_contacted__tC\\+FW {
  color: #220d77;
  background: #e9e7f2;
}

.style_hired__\\+gCNH {
  color: #00a43b;
  background: #e6f6ec;
}

.style_rejected__mjgue {
  color: #d84315;
  background: #fff1ef;
}

.style_spam__M0cqn {
  color: #757575;
  background: lightgray;
}

.style_synced__JAu0Q {
  color: #00a43b;
  background: #e6f6ec;
}

.style_header__B\\+2jZ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.style_titleContainer__nPODz {
  display: flex;
  align-items: center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/views/Leads/LeadsList/style.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,yBAAA;AACF;AAAE;EACE,eAAA;EACA,WAAA;AAEJ;AAAE;EACE,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAEJ;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AACA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;AAEF;AADE;EACE,UAAA;EACA,SAAA;AAGJ;;AACA;EACE,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,qBAAA;AAEF;;AACA;EACE,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAEF","sourcesContent":[".tableHeader {\n  border-bottom: 1px solid #eee;\n  padding: 4px 4px 20px 4px;\n  h2 {\n    font-size: 20px;\n    margin: 0px;\n  }\n  .counter {\n    color: var(--rs_black_100, #434243);\n    font-size: 20px;\n    font-weight: 700;\n    margin-right: 26px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-left: 20px;\n  }\n}\n\n.status {\n  color: #ffc107;\n  font-size: 12px;\n  font-weight: 500;\n  margin-left: 0px;\n  display: flex;\n  padding: 4px 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 100px;\n  background: var(--rs_yellow_10, #fff9e7);\n  white-space: pre;\n  margin: 0px;\n  align-items: center;\n}\n.counter .statBox {\n  display: flex;\n  padding: 10px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 8px;\n  border: 1px solid var(--rs_grey_30, #eee);\n  p {\n    padding: 0;\n    margin: 0;\n  }\n}\n\n.new {\n  color: #757575;\n  background: #f5f5f5;\n}\n\n.inProgress {\n  color: #ffc107;\n  background: #fff9e7;\n}\n\n.contacted {\n  color: #220d77;\n  background: #e9e7f2;\n}\n\n.hired {\n  color: #00a43b;\n  background: #e6f6ec;\n}\n\n.rejected {\n  color: #d84315;\n  background: #fff1ef;\n}\n\n.spam {\n  color: #757575;\n  background: lightgray;\n}\n\n.synced {\n  color: #00a43b;\n  background: #e6f6ec;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHeader": `style_tableHeader__9ULqd`,
	"counter": `style_counter__ARW4G`,
	"status": `style_status__4RU-c`,
	"statBox": `style_statBox__MZLI6`,
	"new": `style_new__yC17U`,
	"inProgress": `style_inProgress__O-QXf`,
	"contacted": `style_contacted__tC+FW`,
	"hired": `style_hired__+gCNH`,
	"rejected": `style_rejected__mjgue`,
	"spam": `style_spam__M0cqn`,
	"synced": `style_synced__JAu0Q`,
	"header": `style_header__B+2jZ`,
	"titleContainer": `style_titleContainer__nPODz`
};
export default ___CSS_LOADER_EXPORT___;
